import { Pressable, StyleSheet, View } from "react-native";
import { ViewProps } from "react-native/Libraries/Components/View/ViewPropTypes";
import { TextProps } from "react-native/Libraries/Text/Text";
import { colors, radii } from "../utils/design";
import { Icon } from "./Icon";
import { Text } from "./Text";

const styles = StyleSheet.create({
  tag: {
    paddingHorizontal: 4,
    paddingVertical: 2,
    borderRadius: radii[4],
    verticalAlign: "middle",
  },

  uppercase: {
    textTransform: "uppercase",
  },

  tagDeletable: {
    flexDirection: "row",
    alignItems: "center",
    paddingLeft: 6,
    paddingVertical: 4,
    borderRadius: radii[4],
  },

  deleteButton: {
    paddingLeft: 2,
    paddingRight: 6,
  },
});

type Props = {
  variant: "neutral" | "negative" | "positive" | "primary" | "primaryInverse";
  children: React.ReactNode;
  uppercase?: boolean;
  style?: TextProps["style"];
};

const backgroundColor: Record<Props["variant"], string> = {
  neutral: colors.neutral[600],
  negative: colors.negative[500],
  positive: colors.positive[500],
  primary: colors.primary[500],
  primaryInverse: colors.primary[900],
};
const textColor: Record<Props["variant"], string> = {
  neutral: colors.neutral[50],
  negative: colors.neutral[900],
  positive: colors.neutral[900],
  primary: colors.neutral[900],
  primaryInverse: colors.primary[500],
};

export const Tag: React.FC<Props> = ({ variant, children, uppercase, style }) => {
  return (
    <Text
      style={[
        styles.tag,
        uppercase && styles.uppercase,
        { backgroundColor: backgroundColor[variant] },
        style,
      ]}
      variant="miniMono"
      color={textColor[variant]}
    >
      {children}
    </Text>
  );
};

type TagDeletableProps = {
  variant: Props["variant"];
  children: React.ReactNode;
  style?: ViewProps["style"];
  onDelete: () => void;
};

export const TagDeletable: React.FC<TagDeletableProps> = ({
  variant,
  children,
  style,
  onDelete,
}) => {
  return (
    <View style={[styles.tagDeletable, { backgroundColor: backgroundColor[variant] }, style]}>
      <Text variant="smallFlat" color={textColor[variant]}>
        {children}
      </Text>

      <Pressable style={styles.deleteButton} onPress={onDelete}>
        <Icon name="close" size={16} color={textColor[variant]} />
      </Pressable>
    </View>
  );
};
